<template>
  <builderall-loader :loading="loadingAll" class="container container-dashboard">
    <div class="row min-vh-100 justify-content-center align-items-center">
      <div class="col-lg-5 col-md-7" v-if="isValidLogin">
        <div
          class="card card-default"
          v-if="!this.$route.params.email || !this.$route.params.password"
        >
          <div class="card-header">
            Login
          </div>

          <div class="card-body">
            <div class="alert alert-danger" v-if="errors && errors.message">
              <p class="mb-0">{{ errors.message }}</p>
            </div>

            <form @submit.prevent="submitLogin" method="POST">
              <div class="form-group">
                <label for="email">E-mail</label>
                <input
                  type="email"
                  id="email"
                  class="form-control"
                  placeholder="user@example.com"
                  v-model="user.email"
                  :class="{'is-invalid': errors && errors.email}"
                  required
                />

                <span v-if="errors.email" class="invalid-feedback" v-text="errors.email[0]"></span>
              </div>
              <div class="form-group">
                <label for="password">Password</label>
                <input
                  type="password"
                  id="password"
                  class="form-control"
                  v-model="user.password"
                  :class="{'is-invalid': errors && errors.password}"
                  required
                />
                <span v-if="errors.password" class="invalid-feedback" v-text="errors.password[0]"></span>
              </div>
              <div class="form-group text-center">
                <button type="submit" class="btn btn-outline-success text-center">Login</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </builderall-loader>
</template>

<script>
import {login} from './../../js/services/editor/login';

export default {
  name: 'Login',
  data() {
    return {
      user: {
        email: '',
        password: ''
      },
      errors: '',
      isValidLogin: false,
      loadingAll: false
    };
  },
  computed:{
    officeToken () {
      return this.$route.params && this.$route.params.office_token ? this.$route.params.office_token : ''
    }
  },
  methods: {
    login(user) {
      this.loadingAll = true;
      login(user)
        .then(async (data) => {
          let response = data.data;

          if (response.success) {
            window.token = response.token;

            this.$store.dispatch('updateUser', response.user);
            this.$store.dispatch('updateOfficeToken', this.officeToken);

            localStorage.token = response.token;
            localStorage.setItem('login', true);
            localStorage.setItem('username', response.user.name);
            localStorage.setItem('email', response.user.email);
            localStorage.setItem('token', response.token);

            var redirectUrl = !response.redirect_url ? '/home' : response.redirect_url;
            var categoryId = false;

            if (this.$route.query && this.$route.query.redirect_url) {
              redirectUrl = this.$route.query.redirect_url;
              categoryId = this.$route.query.category ? this.$route.query.category : false;
              var httpsRemove = 'https://' + location.hostname
              redirectUrl = redirectUrl.replace(httpsRemove, '');
              // if (!redirectUrl.startsWith('/#')) {
              //   redirectUrl = '/#' + redirectUrl
              // }
              console.log('redirectUrl', redirectUrl);
            }

            // se veio pelo exit-popup, verificar o plano do usuário, se for != bundle deve mostrar o alerta sobre os exit popup e liberar a tool
            const officeUrl =  process.env.OFFICE_URL !== 'undefined' ? process.env.OFFICE_URL : "https://office.builderall.com"
            if(localStorage.getItem('is_bundle') == 'exit-popup'){
              await fetch(`${officeUrl}/br/office/user/info/${response.user.email}`)
                      .then(response => response.json())
                      .then(response => {
                        if (response.status == "success") {
                          if (response.data.active_plan.slug != 'bundle-plan') {
                            localStorage.setItem('is_bundle', 'show-message');
                          }
                        }
                    });
              localStorage.setItem('bundle_redirect_url', redirectUrl);
            }

            this.$router.push(redirectUrl + ((categoryId) ? `&category=${categoryId}` : ''));
          } else {
            this.errors = {};
            this.errors.message = response.error;
          }
        })
        .catch(error => {
          console.warn(error);

          if (error.response.data.errors) {
            this.errors = error.response.data.errors;
            this.errors.message = error.response.data.message;
          }
        })
        .finally(() => {
          this.loadingAll = false;
        })
    },
    submitLogin() {
      if (this.user.email && this.user.password) {
        this.login(this.user);
      }
    }
  },
  created() {
    const hostname = window.location.hostname;
    localStorage.setItem('is_bundle', !this.$route.params.plan ? false : this.$route.params.plan == 'exit-popup' ? 'exit-popup' : false);
    const is_bundle = localStorage.getItem('is_bundle');

    const validLoginDomains = [
      'cheetah-editor.builderall.info',
      'cheetah-editor.builderall.io',
      'editor-master.builderall.io',
      'editor-dev.builderall.io',
      'sitebuilder.kub.app.builderall.io',
      'sitebuilder.kub.app.builderall.info'
    ];

    if (this.$route.params.email && this.$route.params.password) {
      this.login({
        email: this.$route.params.email,
        password: this.$route.params.password,
        is_bundle: is_bundle == "exit-popup"
      });
    } else if (validLoginDomains.includes(hostname) || process.env.NODE_ENV === 'development') {
      this.isValidLogin = true;
    } else {
      // window.open('https://office.builderall.com/','_self');
      let officeUrl = typeof process.env.OFFICE_URL !== 'undefined' ? process.env.OFFICE_URL : "https://office.builderall.com"

      window.open(`${officeUrl}/us/office/login`,'_self');
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/dashboard/Login.vue